import { MotionPage } from "@/components/common/motion";
import { ShellSignOutButton } from "@/components/layout/app-shell";
import { RequireDoctor } from "@/components/doctor/require-doctor";
import { useAuth } from "@/contexts/AuthContext";
import type { Doctor } from "@/types/doctor";
import { usePageMeta } from "@/lib/page-meta";

export function SettingsRoute() {
  usePageMeta({
    title: "Settings — HealNova Doctor Portal",
    description: "Manage your HealNova portal appearance and account session.",
  });
  return (
    <RequireDoctor allowUnapproved>{(doctor) => <SettingsPage doctor={doctor} />}</RequireDoctor>
  );
}

function SettingsPage({ doctor }: { doctor: Doctor }) {
  const { user } = useAuth();

  return (
    <MotionPage className="mx-auto w-full max-w-2xl space-y-6">
      <header>
        <p className="text-xs font-semibold tracking-[0.18em] text-rose uppercase">Settings</p>
        <h1 className="mt-2 font-display text-3xl font-semibold tracking-tight">Preferences</h1>
      </header>

      <section className="card-surface p-6 sm:p-7">
        <h2 className="font-display text-lg font-semibold">Account</h2>
        <dl className="mt-5 space-y-4">
          <div>
            <dt className="text-xs font-semibold tracking-wider text-muted-foreground uppercase">
              Signed in as
            </dt>
            <dd className="mt-1.5 text-sm font-medium">{user?.email ?? doctor.email ?? "—"}</dd>
          </div>
          <div>
            <dt className="text-xs font-semibold tracking-wider text-muted-foreground uppercase">
              Verification status
            </dt>
            <dd className="mt-1.5 text-sm font-medium capitalize">{doctor.status}</dd>
          </div>
        </dl>
        <div className="mt-6">
          <ShellSignOutButton />
        </div>
      </section>
    </MotionPage>
  );
}
